import React from 'react'
import PdfRenderer from '../PdfRenderer'
import './PdfPage.scss'

const PdfPage = ({ title, file }) => {
    return (
        <div>
            <section className="pdf-page-layout">
                <div className="container">
                    <div>
                        <div className="text-center col-xs-12 mt-5">
                            <h2>{title}</h2>
                            <hr className="section-divider" />
                        </div>
                        <PdfRenderer file={file} />
                    </div>
                </div>
            </section>
        </div>
    )
}

export default PdfPage
